import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { IpifyIP } from "./ipify.types";

export const ipifyApi = createApi({
  reducerPath: "ipify",
  keepUnusedDataFor: 60 * 10, // 10 minutes
  baseQuery: fetchBaseQuery({
    baseUrl: "https://api.ipify.org/"
  }),
  tagTypes: ["IP"],
  endpoints: (builder) => ({
    getIp: builder.query<IpifyIP, void>({
      query: () => ({
        url: "/",
        method: "GET",
        params: {
          format: "json"
        }
      }),
      providesTags: ["IP"]
    })
  })
});
